// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2b189124","545":"8bb8e8a5","787":"f59577ad"}[chunkId] + ".chunk.js";
};